import { isNil } from 'lodash';

import { SerializableObject } from './serializable-object';
import { ServiceConfigurationScope } from './service-configuration-scope';

export class MobizClientPluginConfiguration extends SerializableObject {
  public id: string;
  public createdUtc: Date;
  public modifiedUtc: Date;
  public createdBy: string;
  public modifiedBy: string;
  public clientPluginKey: string;
  public scope: ServiceConfigurationScope;
  public scopeId: string;
  public enabled: boolean;
  public value: string;
  public valueSchema: string;
  public valueSchemaVersion: number;

  protected coercePropertyType(property: string, value: any) {
    let returnValue = null;
    if (isNil(value)) {
      return returnValue;
    }
    switch (property) {
      case 'modifiedUtc':
      case 'createdUtc':
        if (typeof value === 'string') {
          returnValue = new Date(value);
        } else {
          returnValue = value;
        }
        break;

      default:
        returnValue = value;
    }
    return returnValue;
  }
}
